import { render, staticRenderFns } from "./ExchangeOrderManagement.vue?vue&type=template&id=8366b5f2&scoped=true"
import script from "./ExchangeOrderManagement.vue?vue&type=script&lang=js"
export * from "./ExchangeOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./ExchangeOrderManagement.vue?vue&type=style&index=0&id=8366b5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8366b5f2",
  null
  
)

export default component.exports